export enum AllSelectedMode {
    all,
    none,
    partial
  }